module.exports = __webpack_public_path__ + "img/0db5e8e8313e8316f59779a6200dac48.png";